import { Grid } from "@mui/material";
import React, { useState } from "react";
import { images } from "../../config/images";
import CommonBreadcrumbs from "../../components/Breadcrumb/Breadcrumb";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import "../ContactUs/Contact.css";
import GoogleMap from "../../common/GoogleMap/Map";
import { contact } from "../../config/services";
import FullpageLoader from "../../Fullscreen/FullScreenLoader";
import { toast } from "react-toastify";

const ContactUs = ({ settingAPIData, headerAPIData }) => {
  const [errors, setErrors] = useState({});
  const [contactData, setContactData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handlecontactData = (e) => {
    setErrors({
      ...errors,
      [e.target.name]: "",
    });

    setContactData({ ...contactData, [e.target.name]: e.target.value });
  };

  const handlecontactDataAPI = async () => {
    try {
      const params = {
        name: contactData.name,
        email: contactData.email,
        phone: contactData.phone,
        subject: contactData.subject,
        message: contactData.message,
      };
      const resp = await contact(params);
      if (resp.data.code === 200 || resp.data.code === 201) {
        toast.success(resp?.data?.message);
        setErrors({});
        setContactData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      }
    } catch (error) {
      setErrors(error?.response?.data?.error);
      toast.error("Please Enter Data");
      console.error("Error on submit", error);
    }
  };

  const breadcrumbsData = [
    { label: "Home", url: "/" },
    {
      label: "Contact Us",
      url: "/contactus",
    },
  ];

  const isLoaded = headerAPIData && (Array.isArray(headerAPIData) ? headerAPIData.length > 0 : true);

  if (!isLoaded) return <FullpageLoader />;

  return (
    <>
      <div>
        <div className="about-us-container">
          <div className="molecule left">
            <img
              src={images.leftSpirrel}
              alt="Left Molecule"
              className="left-spinner"
            />
          </div>
          <div className="about-text">
            <h1>Contact Us</h1>
            <CommonBreadcrumbs items={breadcrumbsData} separator="›" />
          </div>
          <div className="molecule right">
            <img
              src={images.rightSpirrel}
              alt="Right Molecule"
              className="right-spinner"
            />
          </div>
        </div>
        <div className="pt-5 contact-container common-sec">
          <Grid container spacing={4} className="contact-grid">
            <Grid item xs={12} md={7}>
              <div className="contact-form-card">
                <div className="contact-form-header">Contact Us</div>
                <p className="contact-form-subtitle">
                  Have questions or suggestions? Send us a message!
                </p>
                <div className="contact-form-body">
                  <div className="contact-form-row">
                    <div className="contact-form-field">
                      <input
                        type="text"
                        placeholder="Your Name"
                        className="contact-input"
                        name="name"
                        value={contactData.name}
                        onChange={handlecontactData}
                      />
                      {errors?.name && <p className="error-valid">{errors.name}</p>}
                    </div>
                    <div className="contact-form-field">
                      <input
                        type="email"
                        placeholder="Your Email"
                        className="contact-input"
                        name="email"
                        value={contactData.email}
                        onChange={handlecontactData}
                      />
                      {errors?.email && <p className="error-valid">{errors.email}</p>}
                    </div>
                  </div>
                  <div className="contact-form-row">
                    <div className="contact-form-field">
                      <input
                        type="tel"
                        placeholder="Phone"
                        className="contact-input"
                        name="phone"
                        value={contactData.phone}
                        onChange={handlecontactData}
                        maxLength={10}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, "");
                        }}
                      />
                      {errors?.phone && <p className="error-valid">{errors.phone}</p>}
                    </div>
                    <div className="contact-form-field">
                      <input
                        type="text"
                        placeholder="Subject"
                        className="contact-input"
                        name="subject"
                        value={contactData.subject}
                        onChange={handlecontactData}
                      />
                      {errors?.subject && <p className="error-valid">{errors.subject}</p>}
                    </div>
                  </div>
                  <div className="contact-form-field contact-form-message">
                    <textarea
                      rows={5}
                      placeholder="Message"
                      className="contact-input contact-textarea"
                      name="message"
                      value={contactData.message}
                      onChange={handlecontactData}
                    />
                    {errors?.message && <p className="error-valid">{errors.message}</p>}
                  </div>
                  <button
                    className="contact-submit-btn"
                    onClick={handlecontactDataAPI}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} md={5}>
              <div className="contact-info-card">
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <LocationOnIcon />
                  </div>
                  <div className="contact-address">
                    <h5>Address</h5>
                    <p>{headerAPIData?.footer?.footer_address}</p>
                  </div>
                </div>
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <CallIcon />
                  </div>
                  <div className="contact-address">
                    <h5>Call Us Now</h5>
                    <p>
                      <a href={`tel:${headerAPIData?.footer?.footer_phone_1}`} className="contact-link">
                        {headerAPIData?.footer?.footer_phone_1}
                      </a>
                    </p>
                  </div>
                </div>
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <EmailIcon />
                  </div>
                  <div className="contact-address">
                    <h5>Email</h5>
                    <p>
                      <a href={`mailto:${headerAPIData?.footer?.footer_email}`} className="contact-link">
                        {headerAPIData?.footer?.footer_email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className="pt-5">
          <GoogleMap />
        </div>
      </div>
    </>
  );
};

export default ContactUs;
